import { __makeTemplateObject } from "tslib";
import { css, flexCenterStyle, spacing, styled, } from '../../../../../foundation';
import { RcTimePickerUtils } from '../utils';
export var StyledSelectionView = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (_a) {
    var size = _a.size;
    var _b = RcTimePickerUtils[size], width = _b.width, height = _b.height;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      ", ";\n      box-sizing: border-box;\n      padding: ", ";\n      flex-wrap: wrap;\n      width: ", ";\n      height: ", ";\n      margin: ", ";\n    "], ["\n      ", ";\n      box-sizing: border-box;\n      padding: ", ";\n      flex-wrap: wrap;\n      width: ", ";\n      height: ", ";\n      margin: ", ";\n    "])), flexCenterStyle, spacing(2), width, height, spacing(-3, -4));
    /** reset wrapper margin */
});
var templateObject_1, templateObject_2;
